import { zodResolver } from '@hookform/resolvers/zod';
import { forwardRef, useRef, useCallback } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router';
import { usePatchInvite } from '../api/use-patch-invite';
import { useInviteStore } from '../store/use-invite-store';

const DEFAULT_EXTRACT_DEFAULTS = () => ({});
const DEFAULT_TRANSFORM_VALUES = (x) => x;

export const PatchInviteForm = forwardRef(function PatchInviteForm(
  {
    extractDefaults = DEFAULT_EXTRACT_DEFAULTS,
    transformValues = DEFAULT_TRANSFORM_VALUES,
    schema,
    nextPath,
    children,
  },
  ref,
) {
  const { invite } = useInviteStore();
  const form = useForm({
    defaultValues: extractDefaults(invite.onlineBookingData, invite),
    resolver: schema ? zodResolver(schema) : undefined,
    mode: 'onChange',
  });
  const patchInvite = usePatchInvite();
  const navigate = useNavigate();

  const transformValuesRef = useRef(transformValues);
  transformValuesRef.current = transformValues;

  const handleSubmit = useCallback(
    async (values) => {
      const transformed = transformValuesRef.current(values);
      const success = await patchInvite.execute(transformed);
      if (success && nextPath) {
        navigate(`/${invite.reference}/${nextPath}`);
      }
    },
    [invite, navigate, nextPath, patchInvite],
  );

  return (
    <FormProvider {...form}>
      <form
        id="patch-invite-form"
        className="contents"
        ref={ref}
        onSubmit={form.handleSubmit(handleSubmit)}
      >
        {children}
      </form>
    </FormProvider>
  );
});
